import React from 'react';
import { List, Typography, Avatar, theme, Card, Button, Flex } from 'antd';
import { CheckSquareFilled, LockOutlined } from '@ant-design/icons';
import { ChargeBeePlanId } from '@prerender/billing-shared';
import { useUpgradePlan } from '../../UpgradePlan/UpgradePlanProvider';

interface UpgradeCardProps {
  onUpgrade: () => void;
}

function AuditLogPageLocked() {
  const { openUpgradePlan } = useUpgradePlan();

  return (
    <>
      <Typography.Title level={5}>Audit Log</Typography.Title>
      <div style={{ position: 'relative' }}>
        <List
          style={{ filter: 'blur(6px)' }}
          itemLayout="horizontal"
          dataSource={Array.from({ length: 7 }, (_, index) => index)}
          renderItem={(item) => <AuditLogListItemSkeleton key={item} />}
        />

        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 10,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <UpgradeCard
            onUpgrade={() => openUpgradePlan(undefined, ChargeBeePlanId.Growth, { ctaLocation: 'Audit Log Page', ctaName: '-' })}
          />
        </div>
      </div>
    </>
  );
}

function UpgradeCard({ onUpgrade }: UpgradeCardProps) {
  const { token } = theme.useToken();

  return (
    <Card
      size="small"
      style={{
        padding: '4px',
        textAlign: 'center',
        minWidth: '421px',
        borderRadius: token.borderRadius,
      }}
    >
      <Flex vertical align="center" gap="middle">
        <LockOutlined
          style={{
            fontSize: '42px',
            color: token.colorIcon,
          }}
        />
        <div>
          <Typography.Title level={5} style={{ marginBottom: token.marginXS, fontSize: token.fontSize }}>
            Track every change made by your team
          </Typography.Title>
          <Typography.Text>Available on the Growth plan.</Typography.Text>
        </div>
        <Button type="primary" variant="filled" color="blue" block onClick={onUpgrade}>
          Upgrade to Growth
        </Button>
      </Flex>
    </Card>
  );
}

function AuditLogListItemSkeleton() {
  const { token } = theme.useToken();
  return (
    <List.Item>
      <List.Item.Meta
        avatar={
          <Avatar
            icon={<CheckSquareFilled style={{ color: token.colorPrimary }} />}
            style={{ background: 'transparent' }}
          />
        }
        title={'Bob enabled Ignore All Query Params.'}
        description={'1 day ago'}
      />
    </List.Item>
  );
}

export default AuditLogPageLocked;
